function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  body,\n  html,\n  #root {\n    height: 100%;\n  }\n\n  .react-datepicker__input-container,\n  .react-datepicker-wrapper {\n    width: 100%;\n  }\n\n  .react-datepicker {\n    border: 2px solid ", " !important;\n    display: flex!important;\n\n    &__triangle {\n      display: none;\n    }\n\n    &__month-container {\n      border-radius: 8px;\n      border: none;\n      padding: 0 10px;\n      float: none;\n\n      .react-datepicker__header {\n        background-color: ", ";\n        border: none;\n\n        .react-datepicker__day-names {\n          margin: 0 3px;\n          border-bottom: 1px solid #D1D1D1;\n\n          .react-datepicker__day-name {\n            color: ", ";\n          }\n        }\n      }\n\n      .react-datepicker__month {\n        .react-datepicker__week {\n          .react-datepicker__day {\n            color: ", ";\n            font-family: ", ";\n            box-sizing: border-box;\n          }\n\n          .react-datepicker__day--today {\n            background-color: ", ";\n            color: ", ";\n            border-radius: 50%;\n          }\n\n          .react-datepicker__day--disabled {\n            color: ", ";\n          }\n        }\n      }\n    }\n  }\n\n  .form-group {\n    margin-bottom: 0.5rem!important;\n  }\n\n  #__filestack-picker {\n    transition: none!important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { createGlobalStyle } from 'styled-components';
import styledNormalize from 'styled-normalize'; // global css; only add to this if there are no other options

export var GlobalStyle = createGlobalStyle(_templateObject(), styledNormalize, function (props) {
  return props.theme.colors.wagGray;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.medGray;
}, function (props) {
  return props.theme.colors.medGray;
}, function (props) {
  return props.theme.fonts.body;
}, function (props) {
  return props.theme.colors.wagGreen;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.boneWhite;
});
var colors = {
  backgroundGray: '#EDEDED',
  backgroundYellow: '#FAE7A8',
  black: '#000000',
  boneWhite: '#E5E0D3',
  champagne: '#FAE7A8',
  copyYellow: '#F9CD46',
  darkGreen: '#085E45',
  darkPurple: '#353F5B',
  darkRed: '#51272F',
  iconBlue: '#5082E5',
  lightBrown: '#7B5533',
  lightPurple: '#7786B7',
  mapBlue: '#1FAEE3',
  medBrown: '#66D482B',
  medGray: '#727272',
  medGreen: '#009972',
  medPurple: '#3C5180',
  medRed: '#DD364A',
  orange: '#FF794D',
  transparent: 'transparent',
  wagGold: '#FAAB43',
  wagGray: '#AAAAAA',
  wagGreen: '#00BF8F',
  wagPurple: '#616A9B',
  wagRed: '#FF5867',
  white: '#FFFFFF'
};
var fontSizes = [8, // 0
10, // 1
12, // 2
16, // 3
18, // 4
20, // 5
22, // 6
24, // 7
26, // 8
32, // 9
36, // 10
40, // 11
48];
var breakpoints = ['40em', // 640px
'52em', // 832px
'64em', // 1024px
'120em'];
var space = [0, // 0
5, // 1
10, // 2
20, // 3
40, // 4
60];
var fontWeights = [200, // 0
300, // 1
400, // 2
500, // 3
600, // 4
700, // 5
800, // 6
900];
var borders = [0, '1px solid', '2px solid'];
var letterSpacings = [];
var radii = [0, // 0
2, // 1
4, // 2
8];
var lineHeights = [1, 1.125, 1.25, 1.5]; // QUESTION: How do we import fonts? Typekit? Typography.com?

var fonts = {
  heading: '"Grilled Cheese"',
  subHeading: '"Helvetica Neue Bold", Helvetica, Arial, sans-serif',
  body: '"Helvetica Neue Regular", Helvetica, Arial, sans-serif'
};
var textInputs = {
  default: {
    backgroundColor: colors.backgroundGray,
    border: 0,
    borderColor: colors.backgroundGray
  },
  light: {
    backgroundColor: colors.white,
    border: 0,
    borderColor: colors.backgroundGray
  }
};
var textAreas = {
  default: {
    border: 0,
    borderColor: colors.backgroundGray
  },
  light: {
    border: 0,
    borderColor: colors.backgroundGray
  }
};
var buttons = {
  primary: {
    backgroundColor: colors.champagne
  },
  secondary: {
    backgroundColor: colors.wagGreen
  }
};
var Theme = {
  borders: borders,
  breakpoints: breakpoints,
  buttons: buttons,
  colors: colors,
  fonts: fonts,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  letterSpacings: letterSpacings,
  lineHeights: lineHeights,
  radii: radii,
  space: space,
  textAreas: textAreas,
  textInputs: textInputs
};
export default Theme;